// extracted by mini-css-extract-plugin
export default {"ramadndiv":"Ramadan_ramadndiv__WHtS9"};